export default {
  label: "Thần Chú Dược Sư",
  url: "https://www.youtube.com/embed/kS0paCt6H1k"
}
